var render = function render(){var _vm=this,_c=_vm._self._c;return _c('owal-banner',{staticClass:"owal-spinner-banner__container"},[_c('owal-spinner-logo',{staticClass:"logo-image"}),_c('div',[_vm._v(" Loading... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }